import { useCallback } from "react";
import { useRequest } from "../useRequest.hook";
import { FetchOptions } from "../../interfaces/fetchOptions.interface";

export interface DA_DeliveryPoint {
    addressId: string;
    modeOfDelivery?: string;
    capacity?: number;
    capacityDescription?: string;
    productNumber?: string;
    id: string;
    name: string;
    description?: string;
}

export interface DA_DeliveryAddress {
    id: string;
    locationId: string;
    streetName: string;
    streetNumber: string;
    zipCode: string;
    city: string;
    countryCode: string;
    isPrimary: boolean;
    description: string;
    deliveryPoints: DA_DeliveryPoint[];
}

export const useDeliveryPointsApi = () => {
    const request = useRequest();

    const getDeliveryPoints = useCallback(
        async (
            customerNumber: string,
            locationId?: string,
            productNumber?: string,
            options?: FetchOptions
        ): Promise<DA_DeliveryAddress[]> => {
            try {
                const response = await request.get(
                    `/deliverypoints/${customerNumber}/${
                        locationId !== null && locationId !== undefined ? locationId + "/" : ""
                    }${productNumber ?? ""}`,
                    undefined,
                    options
                );
                return response as DA_DeliveryAddress[];
            } catch (error) {
                console.error("Error fetching delivery points:", error);
                throw error;
            }
        },
        [request]
    );

    return { getDeliveryPoints };
};
